import { userAccesses as constants } from "store/constants";
import { fetchableInitialState, reduceIsFetching } from "store/factories/fetchable";


const initialState = {
	...fetchableInitialState,
	currentProjectAccessTypes: [],
	parentSubmissionProjectAccessTypes: [],
};

export function userAccesses (state = initialState, action) {
	switch (action.type) {
		case constants.USER_ACCESSES_IS_FETCHING:
			return reduceIsFetching(state, action);
		case constants.USER_ACCESSES_SET_ERROR:
			return {
				...state,
				error: action.payload,
			};
		case constants.USER_ACCESSES_SET_DATA:
			return {
				...state,
				...action.payload,
			};
		case constants.USER_ACCESSES_RESET:
			return initialState;
		default:
			return state;
	}
}
